import { render, staticRenderFns } from "./TraceabilityResults.vue?vue&type=template&id=641b33af&scoped=true"
import script from "./TraceabilityResults.vue?vue&type=script&lang=js"
export * from "./TraceabilityResults.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityResults.vue?vue&type=style&index=0&id=641b33af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b33af",
  null
  
)

export default component.exports